var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.125 9.875C2.54257 9.875 2.25136 9.875 2.02165 9.77985C1.71536 9.65298 1.47202 9.40964 1.34515 9.10335C1.25 8.87364 1.25 8.58243 1.25 8V3.75C1.25 3.04993 1.25 2.6999 1.38624 2.43251C1.50608 2.19731 1.69731 2.00608 1.93251 1.88624C2.1999 1.75 2.54993 1.75 3.25 1.75H7.5C8.08243 1.75 8.37364 1.75 8.60335 1.84515C8.90964 1.97202 9.15298 2.21536 9.27985 2.52165C9.375 2.75136 9.375 3.04257 9.375 3.625M7.625 14.25H11.75C12.4501 14.25 12.8001 14.25 13.0675 14.1138C13.3027 13.9939 13.4939 13.8027 13.6138 13.5675C13.75 13.3001 13.75 12.9501 13.75 12.25V8.125C13.75 7.42493 13.75 7.0749 13.6138 6.80751C13.4939 6.57231 13.3027 6.38108 13.0675 6.26124C12.8001 6.125 12.4501 6.125 11.75 6.125H7.625C6.92493 6.125 6.5749 6.125 6.30751 6.26124C6.07231 6.38108 5.88108 6.57231 5.76124 6.80751C5.625 7.0749 5.625 7.42493 5.625 8.125V12.25C5.625 12.9501 5.625 13.3001 5.76124 13.5675C5.88108 13.8027 6.07231 13.9939 6.30751 14.1138C6.5749 14.25 6.92493 14.25 7.625 14.25Z",
    stroke: "#0062FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.2641101a1acbadabc12c2ef2f7b27c73.svg";
export { ForwardRef as ReactComponent };